var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7322 13.2322C39.7085 12.2559 41.2915 12.2559 42.2678 13.2322L57.2678 28.2322C58.2441 29.2085 58.2441 30.7915 57.2678 31.7678L42.2678 46.7678C41.2915 47.7441 39.7085 47.7441 38.7322 46.7678C37.7559 45.7915 37.7559 44.2085 38.7322 43.2322L51.9645 30L38.7322 16.7678C37.7559 15.7915 37.7559 14.2085 38.7322 13.2322Z",
    fill: "#8C041C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2678 13.2322C23.2441 14.2085 23.2441 15.7915 22.2678 16.7678L9.03553 30L22.2678 43.2322C23.2441 44.2085 23.2441 45.7915 22.2678 46.7678C21.2915 47.7441 19.7085 47.7441 18.7322 46.7678L3.73223 31.7678C2.75592 30.7915 2.75592 29.2085 3.73223 28.2322L18.7322 13.2322C19.7085 12.2559 21.2915 12.2559 22.2678 13.2322Z",
    fill: "#8C041C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.75b109056a9792c4569426cf17ed672b.svg";
export { ForwardRef as ReactComponent };